import { FC } from 'react';
import { Typography } from '@mui/material';

import styles from './ToggleRadioButton.module.scss';

const ToggleRadioButton: FC<{ value: string; label: string; selected: boolean; yesNo?: boolean }> = ({ value, label, selected, yesNo = false }) => (
  <div className={`${styles.toggleButton} ${selected ? styles.selected : ''} ${yesNo ? styles.yesNo : ''}`}>
    {selected ? <Typography variant="h10Semibold">{label}</Typography> : <Typography variant="h10">{label}</Typography>}
  </div>
);

export default ToggleRadioButton;
